<!-- ==========================================
     RIGHT SETTINGS PANEL
=========================================== -->

<div
    class="right-bar"
    (clickOutside)="hide()"
    [exclude]="'.right-bar-toggle'">

    <ngx-simplebar class="h-100">

        <!-- ================= HERO ================= -->

        <div class="settings-header">

            <button
                type="button"
                class="btn-close-settings right-bar-toggle"
                (click)="hide()">

                <i class="bx bx-x"></i>

            </button>

            <div class="settings-avatar">

                <i class="bx bx-cog"></i>

            </div>

            <h3 class="text-white">Ajustes</h3>

            <p>
                Personaliza la apariencia de tu aplicación.
            </p>

        </div>

        <!-- ================= CONTENIDO ================= -->

        <div class="settings-content">

            <!-- Sidebar -->

            <div
                class="settings-section"
                *ngIf="attribute == 'vertical'">

                <div class="section-title">

                    <i class="bx bx-sidebar"></i>

                    <div>

                        <h5>Sidebar</h5>

                        <span>Selecciona el estilo del menú lateral.</span>

                    </div>

                </div>

                <!-- Claro -->

                <label
                    class="setting-card"
                    [class.active]="sidebartype=='light'">

                    <input
                        type="radio"
                        name="sidebar-color"
                        value="light"
                        [checked]="sidebartype=='light'"
                        (change)="changeSidebartype('light')">

                    <div class="setting-icon bg-primary-subtle">

                        <i class="bx bx-sun"></i>

                    </div>

                    <div class="setting-info">

                        <h6>Claro</h6>

                        <p>Diseño limpio y elegante.</p>

                    </div>

                </label>

                <!-- Oscuro -->

                <label
                    class="setting-card"
                    [class.active]="sidebartype=='dark'">

                    <input
                        type="radio"
                        name="sidebar-color"
                        value="dark"
                        [checked]="sidebartype=='dark'"
                        (change)="changeSidebartype('dark')">

                    <div class="setting-icon bg-dark text-white">

                        <i class="bx bx-moon"></i>

                    </div>

                    <div class="setting-info">

                        <h6>Oscuro</h6>

                        <p>Ideal para ambientes con poca luz.</p>

                    </div>

                </label>

                <!-- Compacto -->

                <label
                    class="setting-card"
                    [class.active]="sidebartype=='compact'">

                    <input
                        type="radio"
                        name="sidebar-color"
                        value="compact"
                        [checked]="sidebartype=='compact'"
                        (change)="changeSidebartype('compact')">

                    <div class="setting-icon bg-warning-subtle">

                        <i class="bx bx-grid-alt"></i>

                    </div>

                    <div class="setting-info">

                        <h6>Compacto</h6>

                        <p>Reduce el ancho del menú lateral.</p>

                    </div>

                </label>

                <!-- Coloreado -->

                <label
                    class="setting-card"
                    [class.active]="sidebartype=='colored'">

                    <input
                        type="radio"
                        name="sidebar-color"
                        value="colored"
                        [checked]="sidebartype=='colored'"
                        (change)="changeSidebartype('colored')">

                    <div class="setting-icon bg-success-subtle">

                        <i class="bx bx-palette"></i>

                    </div>

                    <div class="setting-info">

                        <h6>Colorido</h6>

                        <p>Aplica un tema con mayor contraste.</p>

                    </div>

                </label>

            </div>

            <!-- Información -->

            <div class="settings-footer">

                <i class="bx bx-info-circle"></i>

                <span>
                    Los cambios se aplican inmediatamente.
                </span>

            </div>

        </div>

    </ngx-simplebar>

</div>

<!-- Overlay -->

<div class="rightbar-overlay"></div>